import { createStore } from 'vuex';

import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

import profile from './profile';
import specials from './specials';
import dealTemplate from './dealTemplate';
import dealImageLibrary from './dealImageLibrary';
import ui from './ui';
import tutorial from './tutorial';
import bonus from './bonus';
import review from './review';
import pushNotification from './pushNotification';
import partner from './partner';
import ownerPin from './ownerPin';

const store = createStore({
  modules: {
    profile,
    specials,
    dealTemplate,
    dealImageLibrary,
    ui,
    tutorial,
    bonus,
    review,
    pushNotification,
    partner,
    ownerPin,
  },
  strict: import.meta.env.DEV,
  state,
  getters,
  mutations,
  actions,
});

export default store;
